export class FormStatusMapping {
  public static getStatusLabel(status) {
    let label;
    if (status === "CREATED") {
      label = "Draft";
    } else if (status === "SUBMITTED_FOR_APPROVAL") {
      label = "Submitted for Approval";
    } else if (status === "APPROVED") {
      label = "Approved";
    } else if (status === "SHARED") {
      label = "Shared";
    } else if (status === "RECALLED") {
      label = "Recalled";
    } else if (status === "RESENT") {
      label = "Returned";
    } else if (status === "SHARED_WITH_WebC") {
      label = "Forwarded to Web Coordinator";
    } else if (status === "SHARED_WITH_OFFICE_CO") {
      label = "Forwarded to Office Coordinator";
    } else if (status === "SHARED_WITH_WEB_AND_OFFICE") {
      label = "Forwarded to Web and Office";
    } else if (status === "REVERTED") {
      label = "Reverted";
    } else if (status === "APPROVED_WITH_WEB_AND_OFFICE") {
      label = "Approved | With Web and Office Coordinators";
    } else if (status === "APPROVED_WITH_OFFICE_CO") {
      label = "Approved | With Office Coordinator";
    } else if (status === "APPROVED_WITH_WebC") {
      label = "Approved  | With Web Coordinator";
    } else if (status === "APPROVED_WITH_WEB_AND_OFFICE_UPDATED") {
      label = "Approved | With Web and Office Coordinators";
    } else if (status === "APPROVED_WITH_OFFICE_CO_UPDATED") {
      label = "Approved | With Office Coordinator";
    } else if (status === "APPROVED_WITH_WebC_UPDATED") {
      label = "Approved  | With Web Coordinator";
    } else if (status === "APPROVED_WITH_BOTH_OFFICE_UPDATED") {
      label = "Approved | With Web and Office Coordinators";
    } else if (status === "APPROVED_WITH_BOTH_WebC_UPDATED") {
      label = "Approved | With Web and Office Coordinators";
    }
    return label;
  }

  public static getStatusClassName(status: String) {
    let className = "primary";
    switch (status) {
      case "APPROVED":
      case "APPROVED_WITH_WEB_AND_OFFICE":
      case "APPROVED_WITH_OFFICE_CO":
      case "APPROVED_WITH_WebC":
      case "APPROVED_WITH_WEB_AND_OFFICE_UPDATED":
      case "APPROVED_WITH_OFFICE_CO_UPDATED":
      case "APPROVED_WITH_WebC_UPDATED":
      case "APPROVED_WITH_BOTH_OFFICE_UPDATED":
      case "APPROVED_WITH_BOTH_WebC_UPDATED":
        className = "success";
        break;
      case "REVERTED":
        className = "danger";
        break;
      case "SUBMITTED_FOR_APPROVAL":
        className = "lime";
        break;
      case "CREATED":
      case "SHARED":
      case "RECALLED":
      case "RESENT":
      case "SHARED_WITH_WebC":
      case "SHARED_WITH_OFFICE_CO":
      case "SHARED_WITH_WEB_AND_OFFICE":
      case "REVERTED":
        className = "secondary";
        break;

      default:
        break;
    }
    return className;
  }
}
